import angular from 'angular';
import controlManagement from '../Components/TransactionMonitoring/ControlManagement/controlManagement.component';
import transactionMonitoringIncidentManagement from '../Components/TransactionMonitoring/Incidents/incidentManagement.component';
import transactionMonitoringFactoriesModule from './transactionMonitoring.factories.module';

export default angular
    .module('app.transactionMonitoring', [transactionMonitoringFactoriesModule])
    .component('controlManagement', controlManagement)
    .component('transactionMonitoringIncidentManagement', transactionMonitoringIncidentManagement)
    .name;